import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {FetchClientDetailsModel} from "../models/fetch-client-details.model";
import {AddClientDetailsModel} from "../models/add-client-details.model";
import {UpdateClientDetailsModel} from "../models/update-client-details.model";
import {
  FetchClientStatusFilterModel
} from "../models/fetch-client-status-filter.model";
import {CommonService} from "../../../shared/services/common.service";
import {v1URL} from "../../../shared/constants/urls.constants";
import {
  FetchOrganizationTypeFilterModel
} from "../models/fetch-organization-type-filter.model";
import {DeleteClientModel} from "../models/delete-client.model";

@Injectable({
  providedIn: 'root',
})
export class ClientDetailsService {
  enableAddClientForm = new Subject<any>();

  constructor(private commonService: CommonService) {
  }

  fetchClientDetails(payload: FetchClientDetailsModel['request']): Observable<FetchClientDetailsModel['response']> {
    const urlConfig = v1URL.client.details
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.clientId));
  }

  addClientDetails(payload: AddClientDetailsModel['request']): Observable<AddClientDetailsModel['response']> {
    const urlConfig = v1URL.client.add
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  updateClientDetails(payload: UpdateClientDetailsModel['request']): Observable<UpdateClientDetailsModel['response']> {
    const urlConfig = v1URL.client.update
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.clientId), payload);
  }

  fetchClientStatusFilter(): Observable<FetchClientStatusFilterModel['response']> {
    const urlConfig = v1URL.filters.clientStatus
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchOrgTypeListFilter(): Observable<FetchOrganizationTypeFilterModel['response']> {
    const urlConfig = v1URL.filters.orgType
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchClientName(payload: FetchClientDetailsModel['request']): Observable<FetchClientDetailsModel['response']> {
    const urlConfig = v1URL.client.name
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.clientId));
  }

  deleteClient(payload: DeleteClientModel['request']): Observable<DeleteClientModel['response']> {
    const urlConfig = v1URL.client.delete
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
